import { Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import StatusPill from './StatusPill';

export default function AppShell() {
  const { operator, signOut } = useAuth();
  return (
    <div className="min-h-full flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-6 py-4 flex items-center justify-between">
          <div className="font-semibold text-slate-900">
            PowerMove <span className="text-slate-400">·</span>{' '}
            <span className="text-primary-700">Mission Control</span>
          </div>
          <div className="flex items-center gap-4">
            {/* Runbook shortcut — opens the docs/runbooks index on GitHub.
                Operators are PowerMove employees with repo access; no
                auth needed. See docs/runbooks/README.md for the set. */}
            <a
              href="https://github.com/vthatha/powermove/tree/main/docs/runbooks"
              target="_blank"
              rel="noreferrer"
              className="text-sm text-slate-600 hover:text-slate-900 underline decoration-slate-300 decoration-dotted underline-offset-2"
              title="Operator runbooks (opens on GitHub)"
            >
              Runbooks
            </a>
            <StatusPill />
            {operator && (
              <div className="flex items-center gap-3">
                <span className="text-sm text-slate-600">{operator.email}</span>
                <button
                  type="button"
                  onClick={signOut}
                  className="rounded-md border border-slate-300 px-3 py-1 text-sm text-slate-700 hover:bg-slate-50"
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1 mx-auto w-full max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
